<template>
    <div class="room-setting-share-component p-5">
        <div class="room-setting-content-box">
            <h6 class="room-setting-content-title">{{ $t("setting.share.doc.whiteSpace.title") }}</h6>
            <div class="room-setting-content-text-box">
                <p class="room-setting-content-text">{{ $t("setting.share.doc.whiteSpace.explain") }}</p>
            </div>
            <div class="room-setting-input-box">
                <label class="room-setting-label">
                  <input type="checkbox" name="useDocMargin" class="room-setting-radio"
                          v-model="isDocShareMargin"
                          @click="CHANGE_SETTING_DATA({ type:'useDocMargin', value: !isDocShareMargin})">
                  <span>{{ $t("setting.share.doc.whiteSpace.use") }}</span>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations} from "vuex";

export default {
  data(){
    return{
      isDocShareMargin: false
    }
  },
  computed:{
    ...mapGetters('roomSetting', ['params']),
      ...mapGetters('room', ['roomInfo']),
  },
  mounted(){
    this.isDocShareMargin = this.params.useDocMargin ? !this.isDocShareMargin : this.isDocShareMargin;
  },
  methods:{
    ...mapMutations('roomSetting', ['CHANGE_SETTING_DATA'])
  }
}
</script>